// extracted by mini-css-extract-plugin
export default {"socialIcons":"SocialSection_socialIcons__xMq05"};